module.exports = __webpack_public_path__ + "media/images/edit-1c425edb2747823abe7d2dabe2e34570.svg";